import { locationToString, slug } from '@magalu/mixer-utils';
var screenName = 'adicione-protecao';
var sellerName = 'mlseguros';
export var financialServicesSeparateAddToCart = function financialServicesSeparateAddToCart(_ref) {
  var _structure$cookies, _serviceList$0$descri, _serviceList$, _Object$values, _serviceList$2;
  var services = _ref.services,
    structure = _ref.structure,
    serviceSelected = _ref.serviceSelected;
  var userId = structure == null ? void 0 : (_structure$cookies = structure.cookies) == null ? void 0 : _structure$cookies.accountData;
  var _ref2 = (structure == null ? void 0 : structure.route) || {},
    virtualProductId = _ref2.virtualProductId;
  var product = services.product,
    serviceList = services.services;
  var category = (_serviceList$0$descri = serviceList == null ? void 0 : (_serviceList$ = serviceList[0]) == null ? void 0 : _serviceList$.description) !== null && _serviceList$0$descri !== void 0 ? _serviceList$0$descri : null;
  var _ref3 = product || {},
    productSku = _ref3.productSku,
    serviceSlug = _ref3.serviceSlug;
  var selectedOfferId = (_Object$values = Object.values(serviceSelected)) == null ? void 0 : _Object$values[0];
  var foundOffer = serviceList == null ? void 0 : (_serviceList$2 = serviceList[0]) == null ? void 0 : _serviceList$2.offers.find(function (offer) {
    return offer.id === selectedOfferId;
  });
  var _ref4 = foundOffer || {},
    description = _ref4.description,
    validity = _ref4.validity,
    price = _ref4.price;
  return {
    currency: 'BRL',
    event: 'add_to_cart',
    eventCategory: slug(category),
    idusuario: (userId == null ? void 0 : userId.id) || null,
    items: [{
      item_category: "".concat(serviceSlug).concat(validity),
      item_id: virtualProductId || 'null',
      item_name: "adicao-de-servico-ao-produto:".concat(slug(description)) || 'null',
      item_variant: productSku || 'null',
      price: price || 'null'
    }],
    loginAtivo: userId ? 'logado' : 'nao-logado',
    screenName: "seguro-complementar:".concat(slug(category)),
    value: price || 0
  };
};
export var financialServicesSeparateSaleDetailsOnClick = function financialServicesSeparateSaleDetailsOnClick() {
  return {
    content_id: 'detalhes-do-seguro',
    content_type: screenName,
    event: 'select_content'
  };
};
export var financialServicesSeparateSaleOnChange = function financialServicesSeparateSaleOnChange(_ref5) {
  var validity = _ref5.validity,
    selected = _ref5.selected,
    _ref5$serviceType = _ref5.serviceType,
    serviceType = _ref5$serviceType === void 0 ? 'troca-certa' : _ref5$serviceType;
  var isSelect = selected ? 'marcar' : 'desmarcar';
  return {
    content_id: "".concat(isSelect, ":").concat(serviceType, "-").concat(validity, "-meses"),
    content_type: screenName,
    event: 'select_content'
  };
};
export var financialServicesSeparateSaleOnView = function financialServicesSeparateSaleOnView(_ref6) {
  var device = _ref6.device,
    partnerId = _ref6.partnerId,
    userId = _ref6.userId,
    userIsLogged = _ref6.userIsLogged,
    userLocation = _ref6.userLocation;
  return {
    barraLocalizacao: undefined,
    cepPreenchido: (userLocation == null ? void 0 : userLocation.zipCode) ? 1 : 0,
    cidadeuf: locationToString(userLocation),
    device: "site-".concat(device),
    event: 'virtualPageview',
    existeDelivery: undefined,
    hitTimestamp: new Date().getTime(),
    idDaLoja: sellerName,
    idParceiro: partnerId,
    idUsuario: userId,
    loginAtivo: userIsLogged ? 'logado' : 'nao-logado',
    nomeDaLoja: sellerName,
    pageType: 'servico',
    screenName: screenName,
    usuarioClube: undefined
  };
};
export var financialServicesSeparateSalePaymentOnClick = function financialServicesSeparateSalePaymentOnClick() {
  return {
    content_id: 'ir-para-pagamento',
    content_type: screenName,
    event: 'select_content'
  };
};
export var financialServicesSeparateSaleSeeMoreOnClick = function financialServicesSeparateSaleSeeMoreOnClick() {
  return {
    content_id: 'ver-mais',
    content_type: screenName,
    event: 'select_content'
  };
};
export var financialServicesSeparateSaleTermOnClick = function financialServicesSeparateSaleTermOnClick() {
  return {
    content_id: 'termos-de-autorizacao-cobranca',
    content_type: screenName,
    event: 'select_content'
  };
};
export var financialServicesSeparateSaleVideoOnClick = function financialServicesSeparateSaleVideoOnClick() {
  return {
    content_id: 'ver-video',
    content_type: screenName,
    event: 'select_content'
  };
};